import { lmsClient } from "api";

const BankAccountService = {};

// Shared id/name + paging query string. Defaults to page 0 / a large page so
// non-paged callers (getById, dropdowns) still receive all rows; paged screens
// pass explicit pageIndex/pageSize.
const buildBankAccountParams = (data = {}) => {
  const params = new URLSearchParams();
  params.append("bankaccountid", data.bankaccountid || "");
  params.append("bankaccountname", data.bankaccountname || "");
  params.append("pageIndex", data.pageIndex ?? 0);
  params.append("pageSize", data.pageSize ?? 1000);
  params.append("accountNo", data.accountNo || "");
  params.append("branchId", data.branchId || "");
  return params.toString();
};

// Standard bank-account search (maintenance list, getById, dropdowns).
BankAccountService.getBankAccounts = function (data = {}) {
  return lmsClient({
    url: `/lms/lm_bank_account/search?${buildBankAccountParams(data)}`,
    method: "get",
  });
};

// Pairing bank-account picker — head-office accounts only (filtered server-side).
BankAccountService.getBankAccountsPairing = function (data = {}) {
  return lmsClient({
    url: `/lms/lm_bank_account/searchpairingbank?${buildBankAccountParams(data)}`,
    method: "get",
  });
};

// Approval screen — accounts awaiting approval (new / suspend / unsuspend).
BankAccountService.getBankAccountsApproval = function (data = {}) {
  return lmsClient({
    url: `/lms/lm_bank_account/searchapproval?${buildBankAccountParams(data)}`,
    method: "get",
  });
};

// Single bank account by exact id, unfiltered by flag (load record for edit /
// request / approval-detail regardless of status).
BankAccountService.getBankAccountByBankAccountId = function (bankAccountId) {
  return lmsClient({
    url: `/lms/lm_bank_account/ref/${encodeURIComponent(bankAccountId)}`,
    method: "get",
  });
};

BankAccountService.addBankAccount = function (data) {
  return lmsClient({
    url: `/lms/lm_bank_account/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

BankAccountService.updateBankAccount = function (data) {
  const { id, ...requestBody } = data;

  return lmsClient({
    url: `/lms/lm_bank_account/edit`,
    method: "put",
    headers: {
      "x-requestId": id,
    },
    data: requestBody,
  });
};

BankAccountService.approveBankAccount = function (data) {
  return lmsClient({
    url: "/lms/lm_bank_account/approve",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

BankAccountService.rejectBankAccount = function (data) {
  return lmsClient({
    url: "/lms/lm_bank_account/reject",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

BankAccountService.returnBankAccount = function (data) {
  return lmsClient({
    url: "/lms/lm_bank_account/return",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

BankAccountService.requestBankAccount = function (data) {
  return lmsClient({
    url: "/lms/lm_bank_account/request",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

BankAccountService.deleteBankAccount = function (data) {
  return lmsClient({
    url: "/lms/lm_bank_account/delete",
    method: "delete",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

export default BankAccountService;
